<template>
    <div>
        <h4>Anhänge</h4>
        <div class="attachment-container">
            <div v-if="editable" class="upload-box" style="cursor: pointer" @click="showDialog">
                <span class="icon icon-add"></span>
            </div>
            <div v-for="(attachment, index) in medium.attachments" class="attachment-box" v-bind:key="index">
                <RoundedIconButton v-if="!isExternView()" @click="deleteAttachment(attachment)" icon-color="#d70364" size="small"
                                   style="position: absolute; top: 10px; right: 5px"
                                   icon="delete"></RoundedIconButton>
                <RoundedIconButton @click="setAsFavorite(attachment)"
                                   v-if="!isExternView() && attachment.type === 'image'" size="small"
                                   style="position: absolute; top: 40px; right: 5px"
                                   icon="favorite" :icon-color="attachment.is_favorite === 1 ? '#00b6ed' : '#39495669'"
                                   :class="{active: attachment.is_favorite === 1}"></RoundedIconButton>
                <RoundedIconButton v-if="!attachment.url.includes('youtube')" icon-color="#d70364" size="small"
                                   @click="downloadFile(attachment.url)" style="position: absolute; top: 70px; right: 5px"
                                   icon="download"></RoundedIconButton>
                <img v-if="attachment.type === 'image'" :src="attachment.url"/>
                <div class="video-wrapper" v-if="attachment.type === 'video'">
                    <video v-if="!attachment.url.includes('youtube')" preload="metadata">
                        <source :src="attachment.url + '#t=1'" type="video/mp4">
                    </video>
                    <iframe v-if="attachment.url.includes('youtube')" width="160" height="160" :src="attachment.url">
                    </iframe>
                </div>
                <div v-if="attachment.type === 'image'" class="image-button" @click="openImg(attachment.url, index)">
                    <span class="icon icon-image"></span>
                </div>
                <div v-if="attachment.type === 'video'" class="video-button" @click="openVideo(attachment.url, index)">
                    <span class="icon icon-video"></span>
                </div>
            </div>
            <VideoDialog v-if="showVideo" @close="showVideo = false" :url="selectedVideoUrl"
                         @next="showNext" @previous="showPrevious"
                         :show="showVideo"></VideoDialog>
            <ImageDialog v-if="showImg" @close="showImg = false" :url="selectedImageUrl"
                         @next="showNext" @previous="showPrevious" :show="showImg"></ImageDialog>
            <Dialog v-if="showUploadDialog" :show-close-button="true" :show="showUploadDialog"
                    :has-backdrop="true" width="50%"
                    @close="closeDialog">
                <div style="width: 100%">
                    <h2>Anhang hinzufügen</h2>
                    <InputDetail label="Youtube-Link" value=""
                                 placeholder="https://www.youtube.com/embed/{your-video-id}}"
                                 image="youtube.png" :iconBorder="true" @input="setYoutubeLink"></InputDetail>
                    <div style="margin-top: 10px; margin-bottom: 10px;justify-content: center;align-items: center;background-color: lightgray;width: 100%;display: flex;flex-direction: column"
                         id="drop_zone" @drop="dropHandler($event)" @dragover="dragOverHandler($event)">
                        <div style="display: flex; flex-flow: row;">
                            <div style="position: relative;display: flex;justify-content: center;align-items: center">
                                <span style="position: initial; margin-right: 10px" class="icon icon-add"></span>
                            </div>
                            <div style="display: flex;justify-content: center;align-items: center;flex-direction: column">
                                <p style="font-size: 22px; margin: 0">Drag and Drop</p>
                                <p style="font-size: 12px; margin: 0">Oder vom Computer <label
                                        style="text-decoration: underline;cursor: pointer">
                                    laden
                                    <input multiple @change="setDirectFiles" id="file-input" type="file"
                                           style="position: fixed; top: -100em">
                                </label></p>
                            </div>
                        </div>
                        <DashboardImagePreview :files="files" @delete="deleteFromFiles"></DashboardImagePreview>
                    </div>
                    <div style="display: flex;flex-direction: row; align-items: center;">
                        <AdaButton v-if="!uploading" class="submit" type="createButton"
                                   title="Bestätigen"
                                   @click="this.uploadFiles"></AdaButton>
                        <label style="margin-left: 30px">
                            {{this.getStatus()}}
                        </label>
                    </div>
                </div>
            </Dialog>
        </div>
    </div>
</template>

<script>
    import VideoDialog from "../../components/dialog/VideoDialog";
    import ImageDialog from "../../components/dialog/ImageDialog";
    import Dialog from "../../components/dialog/Dialog";
    import {RepositoryFactory} from "../../scripts/RepositoryFactory";
    import InputDetail from "../../components/inputs/InputDetail";
    import RoundedIconButton from "../../components/buttons/RoundedIconButton";
    import AdaButton from "../../components/buttons/AdaButton";
    import DashboardImagePreview from "./DashboardImagePreview";

    const AttachmentsRepository = RepositoryFactory.get('attachments');

    export default {
        name: "DashboardAttachment",
        props: {
            medium: {
                required: true
            },
            editable: {
                type: Boolean,
                default: false,
            }
        },
        components: {
            DashboardImagePreview,
            AdaButton,
            VideoDialog,
            ImageDialog,
            Dialog,
            InputDetail,
            RoundedIconButton
        },
        data: function () {
            return {
                activeAttachmentIndex: null,
                youtubeLink: null,
                selectedVideoUrl: null,
                showVideo: false,
                selectedImageUrl: null,
                showImg: false,
                showUploadDialog: false,
                droppedFiles: [],
                chosenFiles: [],
                uploading: false,
                fileSizeLimit: 20000000,
                fn: null
            }

        },
        mounted() {
            this.fn = () => {
                for (let i = 0; i < this.medium.attachments.length; i++) {
                    let attachment = this.medium.attachments[i];
                    if (attachment.is_favorite === 1) {
                        this.openImg(attachment.url);
                    }
                }
            };
            this.$root.$on('openFavorite', this.fn);
        },
        beforeDestroy(){
            this.$root.$off('openFavorite', this.fn);
        },
        computed: {
            files() {
                return this.droppedFiles.concat(this.chosenFiles);
            }
        },
        methods: {
            isExternView() {
                return typeof this.$route.query.key !== 'undefined';
            },
            downloadFile(url) {
                let xhr = new XMLHttpRequest();
                xhr.open("GET", url, true);
                xhr.responseType = "blob";
                xhr.onload = function () {
                    let urlCreator = window.URL || window.webkitURL;
                    let imageUrl = urlCreator.createObjectURL(this.response);
                    let tag = document.createElement('a');
                    tag.href = imageUrl;
                    let urlPath = url.split('/');
                    let fileName = urlPath[urlPath.length - 1];
                    tag.download = fileName;
                    document.body.appendChild(tag);
                    tag.click();
                    document.body.removeChild(tag);
                };
                xhr.send();
            },
            async setAsFavorite(attachment) {
                try {
                    attachment.is_favorite = 1;
                    await AttachmentsRepository.updateAttachment(attachment.id, attachment);
                    this.$noty.success('Der neue Favorit wurde abgespeichert');
                    this.$store.dispatch('campaign/fetch', this.$route.params.id)
                        .then(
                            console.log('campaign fetched')
                        )
                        .catch(e => console.error(e));
                } catch (e) {
                    console.error(e);
                    this.$noty.error('Fehler bei der Favoritenvergabe');
                }
            },
            async deleteAttachment(attachment) {
                try {
                    await AttachmentsRepository.deleteAttachment(attachment.id);
                    this.$noty.success('Die Datei wurde erfolgreich gelöscht');
                    this.$store.dispatch('campaign/fetch', this.$route.params.id)
                        .catch(e => console.error(e));
                } catch (e) {
                    console.error(e);
                    this.$noty.error('Fehler beim Löschen der Datei');
                }
            },
            getStatus() {
                let res = 'Ausgewählte Dateien: ' + (this.droppedFiles.length + this.chosenFiles.length);
                if (this.uploading) {
                    res = 'Dateien werden hochgeladen. Bitte warten...'
                }
                return res;
            },
            setDirectFiles() {
                //this.chosenFiles.length = 0;
                let ele = document.getElementById('file-input');
                for (let i = 0; i < ele.files.length; i++) {
                    if (this.isFileValid(ele.files[i])) {
                        this.chosenFiles.push(ele.files[i]);
                    }
                }
            },
            setYoutubeLink(val) {
                this.youtubeLink = val;
            },
            showDialog() {
                this.showUploadDialog = true;
                this.droppedFiles.length = 0;
            },
            async closeDialog() {
                this.showUploadDialog = false;
            },
            async uploadFiles() {
                this.uploading = true;
                try {
                    for (let i = 0; i < this.files.length; i++) {
                        let formData = new FormData();
                        formData.append('file1', this.files[i]);
                        formData.append('medium_id', this.medium.id + '');
                        await AttachmentsRepository.createAttachment(formData);
                    }
                    if (this.youtubeLink && this.youtubeLink !== '') {
                        let formData = new FormData();
                        formData.append('type', 'video');
                        formData.append('medium_id', this.medium.id + '');
                        formData.append('url', this.youtubeLink);
                        await AttachmentsRepository.createAttachment(formData);
                    }
                    this.$noty.success("Alle Dateien erfolgreich hochgeladen!");
                    this.showUploadDialog = false;
                    this.$store.dispatch('campaign/fetch', this.$route.params.id);
                } catch (e) {
                    console.error(e);
                    this.$noty.error(e.message);
                }
                this.uploading = false;
                this.droppedFiles.length = 0;
                this.chosenFiles.length = 0;
                this.youtubeLink = '';
            },
            deleteFromFiles(file) {
                let deleted = false;
                for (let i = 0; i < this.droppedFiles.length; i++) {
                    if (this.compareFiles(file, this.droppedFiles[i])) {
                        this.droppedFiles.splice(i, 1);
                        deleted = true;
                        break;
                    }
                }
                if (!deleted) {
                    for (let i = 0; i < this.chosenFiles.length; i++) {
                        if (this.compareFiles(file, this.chosenFiles[i])) {
                            this.chosenFiles.splice(i, 1);
                            break;
                        }
                    }
                }
            },
            compareFiles(file1, file2) {
                return file1.name === file2.name &&
                    file1.lastModified === file2.lastModified &&
                    file1.size === file2.size &&
                    file1.type === file2.type;
            },
            openVideo(url, index) {
                this.activeAttachmentIndex = index;
                this.selectedVideoUrl = url;
                this.showVideo = true;
            },
            openImg(url, index) {
                this.activeAttachmentIndex = index;
                this.selectedImageUrl = url;
                this.showImg = true;
            },
            showNext() {
                if (this.activeAttachmentIndex >= this.medium.attachments.length - 1) {
                    this.activeAttachmentIndex = 0;
                } else {
                    this.activeAttachmentIndex += 1;
                }
                this.showAttachment();
            },
            showPrevious() {
                if (this.activeAttachmentIndex === 0) {
                    this.activeAttachmentIndex = this.medium.attachments.length - 1;
                } else {
                    this.activeAttachmentIndex -= 1;
                }
                this.showAttachment();
            },
            showAttachment() {
                let attachment = this.medium.attachments[this.activeAttachmentIndex];
                if (attachment.type === 'video') {
                    this.showVideo = true;
                    this.selectedVideoUrl = attachment.url;
                    this.showImg = false;
                } else {
                    this.showImg = true;
                    this.selectedImageUrl = attachment.url;
                    this.showVideo = false;
                }
            },
            isFileValid(file) {
                let res = false;
                if (file.size > this.fileSizeLimit) {
                    this.$noty.error('Die Datei darf nicht größer als 20MB sein. Größe: ' + ((file.size / 1000000).toFixed(1)) + 'MB');
                } else {
                    res = true;
                }
                return res;
            },
            dropHandler(ev) {
                // Prevent default behavior (Prevent file from being opened)
                ev.preventDefault();

                if (ev.dataTransfer.items) {
                    // Use DataTransferItemList interface to access the file(s)
                    for (let i = 0; i < ev.dataTransfer.items.length; i++) {
                        // If dropped items aren't files, reject them
                        if (ev.dataTransfer.items[i].kind === 'file') {
                            var file = ev.dataTransfer.items[i].getAsFile();
                            if (this.isFileValid(file)) {
                                this.droppedFiles.push(file);
                            }
                        }
                    }
                }
            },
            dragOverHandler(ev) {
                // Prevent default behavior (Prevent file from being opened)
                ev.preventDefault();
            }
        }
    }
</script>

<style lang="scss" scoped>
    img {
        width: 100%;
        height: auto;
    }

    video {
        width: inherit;
        height: inherit;
    }

    #drop_zone {
        padding: 20px;
    }


    .icon-image, .icon-video {
        position: absolute;
        top: 18px;
    }

    .attachment-container {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
    }

    .attachment-container > * {
        margin-right: 8px;
        margin-bottom: 8px;
    }

    .attachment-box, .upload-box {
        position: relative;
        width: 160px;
        height: 160px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .attachment-box {
        background-color: rgb(1, 1, 1);
    }

    .upload-box {
        background-color: white;
    }

    .image-button {
        position: absolute;
        left: 33%;
        width: 60px;
        height: 60px;
        background-color: $blue;
        border-radius: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .video-button {
        position: absolute;
        left: 33%;
        width: 60px;
        height: 60px;
        background-color: $pink;
        border-radius: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .icon {
        font-size: 24px;
        color: white;
    }

    .icon-add {
        color: $pink;
        font-size: 36px;
    }

    .video-wrapper {
        width: inherit;
        height: inherit;
        background-color: rgba(1, 1, 1, 0.5);
    }

    ::v-deep .rounded-icon-button-wrapper {
        opacity: 0;
        z-index: -1;
        cursor: pointer;
        transition: all .3s ease-in-out;
    }

    .attachment-box:hover > ::v-deep .rounded-icon-button-wrapper, ::v-deep .rounded-icon-button-wrapper.active {
        opacity: 1;
        z-index: 10;
    }

    @media only screen and (max-width: 767px) {
        .attachment-box, .upload-box {
            width: calc(100vw / 2.6);
            height: calc(100vw / 2.6);
        }
    }

</style>